import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import PropTypes from 'prop-types';

function MpidModal({
  showConfirmModal,
  onSuccess,
  onCancel,
  booking,
  selectedMpid
}) {
  return (
    <Modal isOpen={showConfirmModal} toggle={onCancel}>
      <ModalHeader toggle={onCancel}>
        Please confirm for MPID update
      </ModalHeader>
      <ModalBody>
        <div>
          <span>Appointment Booking Name:</span> {booking.userName}
        </div>
        <div>
          <span>Appointment Mobile Number: </span> {booking.userMobile}
        </div>

        {Array.isArray(selectedMpid) && selectedMpid.length > 0 && (
          <>
            <div style={{ marginTop: '10px' }}>
              <span>Selected Mpid Name : </span>
              {`${selectedMpid[0].first_name} ${selectedMpid[0].last_name} (${selectedMpid[0].mpid})`}
            </div>
            <div>
              <span>Selected Mpid Mobile : </span>
              {selectedMpid[0].mobile}
            </div>
          </>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={onSuccess}>
          Yes
        </Button>
        <Button color="secondary" onClick={onCancel}>
          No
        </Button>
      </ModalFooter>
    </Modal>
  );
}

MpidModal.propTypes = {
  showConfirmModal: PropTypes.bool.isRequired,
  onSuccess: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  booking: PropTypes.object.isRequired,
  selectedMpid: PropTypes.array.isRequired
};

export default MpidModal;
